'use client';

import { useEffect, useState } from 'react';

type NavItem = {
  id: string;
  label: string;
};

export function useScrollNavigation(navItems: NavItem[]) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector<HTMLElement>(`#${sectionId}`);
    if (element) {
      const offsetTop = element.offsetTop - 80; // Account for fixed header
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
      setActiveSection(sectionId); // Set active section immediately
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const scrollPosition = window.scrollY + 100;

      let found = false;
      for (const item of navItems) {
        const element = document.querySelector<HTMLElement>(`#${item.id}`);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(item.id);
            found = true;
            break;
          }
        }
      }

      // Reset to empty if at top or no section found
      if (window.scrollY < 100 || !found) {
        setActiveSection('');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [navItems]);

  return {
    isScrolled,
    activeSection,
    scrollToSection,
  };
}
